import * as z from "zod";

export const setReturnItemDisposition = {
  name: "setReturnItemDisposition" as const,
  input: z.object({
    returnId: z.string(),
    itemsWithDisposition: z.record(
      z.string(),
      z.object({
        grade: z.optional(z.string()),
        outcome: z.optional(z.string()),
        notes: z.optional(z.string()),
      }),
    ),
    itemsToRestock: z.optional(z.record(z.string(), z.boolean())),
  }),
  output: z.literal("SUCCESS"),
};

export type SetReturnItemDispositionInput = z.infer<
  typeof setReturnItemDisposition.input
>;
